import Spec from "./Spec";

export function buildFunction(spec: Spec, func, dependenciesName: string = "dependencies") {
    const regex = /\[((\w|\d|\:|\_|\@)*)\]/g;
    let m;
    let newF: string = func;
    let containsOperator = ["+", "-", "*", "/"].some((op) => func.includes(op));
    while ((m = regex.exec(func)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            if (groupIndex === 0) {
                let key = match.slice(1, -1);
                if (key !== spec.key) {
                    if (key.startsWith("N1")) {
                        newF = newF.replace(
                            match,
                            `(+this.${dependenciesName}?.['${match.slice(4, -1)}']?.value || 0)`
                        );
                    } else if (key.includes("@:")) {
                        // SPECIFIC
                        const prefixes = [
                            "2573",
                            "3310A_4",
                            "3310TIC_1",
                            "3310TIC_2",
                            "3310TIC2EX1",
                            "3310TIC_3",
                            "3310TIC_4",
                            "3517SC_3",
                            "2777",
                            "DAS2T",
                        ];
                        if (prefixes.some((prefix) => spec.specManager?.name?.startsWith(prefix))) {
                            newF = newF.replace(
                                match,
                                `(+this.specManager.declarationBase.sheets.filter(s => s.cerfaNumber.startsWith('${
                                    key.split("@")[0]
                                }')).reduce((acc, curr) => acc + curr?.fields?.['${
                                    key.split(":")[1]
                                }']?.value || 0, 0))`
                            );
                        } else {
                            newF = newF.replace(
                                match,
                                `(+Object.values(this.specManager.bundleBase.bundleSheets).filter(bs => bs.cerfaNumber.startsWith('${
                                    key.split("@")[0]
                                }')).reduce((acc, curr) => acc + curr?.fields?.['${
                                    key.split(":")[1]
                                }']?.value || 0, 0))`
                            );
                        }
                    } else if (key.startsWith("RAD")) {
                        newF = newF.replace(
                            match,
                            match.includes("RAD")
                                ? `(+this.specManager.radicals?.['${match.slice(4, -1)}'] || 0)`
                                : `(+this.${dependenciesName}?.["${match.slice(
                                      1,
                                      -1
                                  )}"]?.value || 0)`
                        );
                    } else if (match.includes("CPT")) {
                        newF = newF.replace(
                            match,
                            `(+this.specManager?.bundleBase?.aaClassesBalanceSum?.[${match
                                .slice(1, -1)
                                .replace("CPT", "")}] || 0)`
                        );
                    } else if (containsOperator) {
                        newF = newF.replace(
                            match,
                            `(+this.${dependenciesName}?.["${match.slice(1, -1)}"]?.value || 0)`
                        );
                    } else if (key.startsWith("SUM")) {
                        newF = newF.replace(
                            match,
                            `(+Object.values(this.${dependenciesName}).reduce((acc, curr) => acc + +curr.value || 0, 0))`
                        );
                    } else if (key.startsWith("2561") && spec.specManager.name.match(/_(.*)/)) {
                        // SPECIFIC
                        // 2561
                        // declaration multi-beneficiaries, independent blocks of '3 forms linked together' in the same declaration
                        const suffix = spec.specManager.name.match(/_(.*)/)[1];
                        newF = newF.replace(
                            match,
                            `(this.specManager.declarationBase.specs?.["2561_${suffix}:${spec.key}"]?.value || '')`
                        );
                    } else {
                        newF = newF.replace(
                            match,
                            `(this.${dependenciesName}?.["${match.slice(1, -1)}"]?.value || '')`
                        );
                    }
                } else {
                    console.error(
                        "buildFunction key === spec.key for= ",
                        spec.uniqueKey,
                        " function= ",
                        func
                    );
                }
            }
        });
    }
    return newF;
}
